import { render, staticRenderFns } from "./UserFormSubmitButton.vue?vue&type=template&id=08520cdc&"
import script from "./UserFormSubmitButton.vue?vue&type=script&lang=js&"
export * from "./UserFormSubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports